"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormHint;
function FormHint(props) {
  var error = props.error,
    warning = props.warning,
    info = props.info;
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-hint form-hint--error"
    }, error);
  }
  if (warning) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-hint form-hint--warning"
    }, warning);
  }
  if (info) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-hint form-hint--info"
    }, info);
  }
  return null;
}
;